export function formatStreefduur(minuten: number | null): string {
  const n = minuten ?? 600;
  return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, '0')}`;
}

export function parseStreefduur(tekst: string): number | null {
  if (!tekst.trim()) return null;
  const match = /^(\d{1,2}):([0-5]\d)$/.exec(tekst.trim());
  const minuten = match ? Number(match[1]) * 60 + Number(match[2]) : NaN;
  if (!Number.isInteger(minuten) || minuten < 1 || minuten > 1440) {
    throw new Error('Vul uren:minuten in, bijvoorbeeld 10:00 of 11:00 (maximaal 24:00).');
  }
  return minuten;
}
